<template>
  <div>
    <div class="prowl">
      <div class="prowl-around">
        <div class="module-title">
          <div class="title-box">
            巡岗巡查统计波段图
          </div>
        </div>
        <div class="subtitle">
          <div class="prowl-list">
            <div class="prowl-num">
              {{ infoData.spectionareasNum }}<span>个</span>
            </div>
            <div class="prowl-label">巡查点总数</div>
          </div>
          <!-- <div class="prowl-list">
            <div class="prowl-num">
              {{ infoData.spectionareasHeNum }}<span>个</span>
            </div>
            <div class="prowl-label">巡查上报隐患数量</div>
          </div> -->
        </div>
        <stacked-line-chart
          v-if="infoData.patrolStatistics.length > 0"
          class="prowl-around-line"
          :echartsData="infoData.patrolStatistics"
        >
        </stacked-line-chart>
        <div v-else class="noData">暂无数据</div>
      </div>
    </div>
    <div class="accomplish-ranking-list" v-if="isAccomplishList">
      <div class="accomplish-title-box">
        <div
          class="left-button"
          @click="isAccompCut"
          v-show="isAccomplishList"
        ></div>
        <div
          
        >
          <span style="margin-left: 20px;line-height:40px" >隐患整改率排行榜</span>
        </div>

        <div
          class="right-button"
          @click="isAccompCut"
          v-show="!isAccomplishList"
        ></div>
      </div>
      <div class="accomplish-list-title">
        <div class="title-one">排名</div>
        <div class="title-two">学院名称</div>
        <div class="title-three">完成率</div>
      </div>
      <div
        class="accomplish-list-content"
        v-if="infoData.schoolHazardCompletionRate.length > 0"
      >
        <div
          class="list-item"
          v-for="(item, index) in infoData.schoolHazardCompletionRate"
          :key="index"
        >
          <div class="item-one">{{ index + 1 }}</div>
            <div class="item-two">{{ item.schoolName }}</div>
          <div class="item-three">{{ item.theCompletionRate }}</div>
        </div>
      </div>
      <div class="noData" v-else>
        暂无数据
      </div>
    </div>
    <div class="accomplish-ranking-list" v-else>
      <div class="accomplish-title-box">
        <div
          class="left-button"
          @click="isAccompCut"
          v-show="isAccomplishList"
        ></div>
        <div style="margin-left: 135px;
                ">
          <span style="line-height:40px"
            >巡查完成率排行榜</span
          >
        </div>
        <div
          class="right-button"
          @click="isAccompCut"
          v-show="!isAccomplishList"
        ></div>
      </div>

      <div class="accomplish-list-title">
        <div class="title-one">排名</div>
        <div class="title-two">学院名称</div>
        <div class="title-three">完成率</div>
      </div>
      <div
        class="accomplish-list-content"
        v-if="infoData.patrolStatisticsRank.length > 0"
      >
        <div
          class="list-item"
          v-for="(item, index) in infoData.patrolStatisticsRank"
          :key="index"
        >
          <div class="item-one">{{ index + 1 }}</div>
            <div class="item-two">{{ item.schoolName }}</div>
          <div class="item-three">{{ item.doneRate }}%</div>
        </div>
      </div>
      <div class="noData" v-else>
        暂无数据
      </div>
    </div>
    <div class="hidden-danger-now">
      <div class="module-title">
        <div class="title-box">
          隐患实时动态
        </div>
      </div>
      <hidden-danger-now
        :hiddenTroubleList="infoData.hiddenTroubleList"
      ></hidden-danger-now>
    </div>
    <div class="hidden-danger-title">
      <module-title title="发现隐患类占比"></module-title>
    </div>
    <div class="hidden-danger-proportion">
      <hidden-danger-pie
        type="s"
        v-if="infoData.mainSchoolProportionOfHiddenDangers.length > 0"
        :echartsData="infoData.mainSchoolProportionOfHiddenDangers"
      ></hidden-danger-pie>
      <div v-else class="noData">
        暂无数据
      </div>
    </div>
    <div class="four-color-title">
      <module-title title="风险四色分布图"></module-title>
    </div>
    <div class="four-color-module">
      <four-color-echarts
        v-if="infoData.riskLevelCompare.length > 0"
        :echartsData="infoData.riskLevelCompare"
      ></four-color-echarts>
      <div v-else class="noData">
        暂无数据
      </div>
    </div>
  </div>
</template>
<script>
import stackedLineChart from "./stackedLineChart";
import hiddenDangerNow from "./hiddenDangerNow";
import moduleTitle from "./moduleTitle";
import riskLeveEcharts from "./riskLeveEcharts";
import fourColorEcharts from "@/components/fourColorEcharts";
import hiddenDangerPie from "./hiddenDangerPie";
export default {
  name: "SecuritySituation",
  props: {
    infoData: {
      type: Object,
      default: {
        return: {}
      }
    }
  },
  components: {
    stackedLineChart,
    hiddenDangerNow,
    moduleTitle,
    riskLeveEcharts,
    fourColorEcharts,
    hiddenDangerPie
  },
  data() {
    return {
      isAccomplishList: false
    };
  },
  methods: {
    isAccompCut() {
      this.isAccomplishList = !this.isAccomplishList;
    }
  }
};
</script>
<style lang="scss" scoped>
.accomplish-ranking-list {
  background: url("~@/assets/img/bigDataCollge/school-view-bg.png");
  background-size: 100% 100%;
  width: 440px;
  height: 500px;
  position: absolute;
  top: 400px;
  left: 90px;
  padding-top: 10px;
  .accomplish-title-box {
    display: flex;
    flex-direction: row;
    height: 40px;
    width: 100%;
    .left-button {
      margin-top: 5px;
      margin-left: 105px;
      width: 30px;
      height: 30px;
      background-color: yellow;
      cursor: pointer;
      background: url("~@/assets/img/schoolBigData/accomplish-cut.png");
      background-size: 100% 100%;
      -webkit-transform: rotate(180deg);
      -moz-transform: rotate(180deg);
      -o-transform: rotate(180deg);
      -ms-transform: rotate(180deg);
      transform: rotate(180deg);
    }
    span {
      margin-left: 20px;
      margin-right: 20px;
      width: 160px;
      text-align: center;
      height: 30px;
      line-height: 30px;
      font-size: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgb(203, 224, 255);
    }
    .right-button {
      margin-top: 5px;
      width: 30px;
      height: 30px;
      cursor: pointer;
      background: url("~@/assets/img/schoolBigData/accomplish-cut.png");
      background-size: 100% 100%;
    }
  }
  .accomplish-list-title {
    margin: 10px 30px;
    height: 30px;
    width: 410px;
    display: flex;
    flex-direction: row;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #f1f3ff;
    .title-one {
      width: 100px;
      line-height: 30px;
      text-align: center;
    }
    .title-two {
      width: 160px;
      line-height: 30px;
      text-align: center;
    }
    .title-three {
      width: 100px;
      line-height: 30px;
      text-align: center;
    }
  }
  .accomplish-list-content {
    margin: 10px 30px;
    width: 410px;
    max-height: 390px;
    overflow-y: scroll;
    .list-item {
      width: 380px;
      height: 38px;
      border-radius: 4px;
      background: rgba(17, 165, 215, 0.2);
      margin-top: 5px;
      display: flex;
      flex-direction: row;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      .item-one {
        width: 100px;
        line-height: 38px;
        text-align: center;
        color: #e7ebff;
      }
      .item-two {
        width: 160px;
        line-height: 38px;
        text-align: center;
        color: #ebeeff;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .item-three {
        width: 100px;
        line-height: 38px;
        text-align: center;
        color: #fff04d;
      }
    }
  }
  .noData {
    margin: 10px 40px;
    width: 410px;
    height: 390px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    color: rgba(233, 237, 255, 0.8);
    font-size: 20px;
  }
}
.prowl {
  position: absolute;
  top: 80px;
  left: 90px;
  width: 440px;
  height: 300px;
  display: flex;
  justify-content: center;
  .module-title {
    height: 40px;
    width: 220px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .title-box {
      line-height: 40px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgb(203, 224, 255);
    }
  }
  .prowl-around {
    width: 100%;
    height: 100%;
    background: url("~@/assets/img/bigDataCollge/chart-view-bg.png") center center no-repeat;
    background-size: 100% 100%;
  }
  .subtitle {
    margin-top: 5px;
    display: flex;
    justify-content: space-between;
  }
  .prowl-list {
    width: 136px;
    text-align: center;
    position: relative;
    top: -2px;
    &:first-child {
      padding-left: 25px;
    }
    &:last-child {
      padding-right: 10px;
    }
  }
  .prowl-label {
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #c4f0ff;
  }
  .prowl-num {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #c4f0ff;
    line-height: 22px;
    background: linear-gradient(180deg, #eeeeee 0%, #fff45d 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    span {
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #c4f0ff;
      line-height: 22px;
      background: linear-gradient(180deg, #eeeeee 0%, #fff45d 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  .prowl-around-line {
    height: 250px;
    padding: 0 10px;
  }
  .noData {
    height: 210px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    color: rgba(233, 237, 255, 0.8);
    font-size: 20px;
  }
}
.hidden-danger-now {
  position: absolute;
  top: 600px;
  left: 560px;
  width: 400px;
  height: 300px;
  background: url("~@/assets/img/bigDataCollge/chart-view-bg.png") center center no-repeat;
  background-size: 100% 100%;
  .module-title {
    height: 40px;
    width: 200px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .title-box {
      line-height: 40px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgb(203, 224, 255);
    }
  }
}
.hidden-danger-title {
  position: absolute;
  top: 600px;
  left: 990px;
}
.hidden-danger-proportion {
  position: absolute;
  top: 640px;
  left: 990px;
  width: 400px;
  height: 256px;
  //   echart-bg
  background: url("~@/assets/img/schoolBigData/account-module-bg.png") center center no-repeat;
  background-size: 100% 100%;
}
.noData {
    height: 256px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    color: rgba(233, 237, 255, 0.8);
    font-size: 20px;
  }
.four-color-title {
  position: absolute;
  top: 600px;
  left: 1420px;
}
.four-color-module {
  position: absolute;
  top: 640px;
  left: 1420px;
  width: 400px;
  height: 256px;
  background: url("~@/assets/img/schoolBigData/account-module-bg.png") center center no-repeat;
  background-size: 100% 100%;
  .noData {
    height: 260px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    color: rgba(233, 237, 255, 0.8);
    font-size: 20px;
  }
}
</style>
